import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const commissionApi = {
  findAll: (params: { month: number; year: number; staffId?: number }): AxiosPromise<any> =>
    request({
      url: "/v1/admin/commission",
      params,
    }),

  lock: (data: { month: number; year: number }): AxiosPromise<any> =>
    request({
      url: "/v1/admin/commission/lock",
      method: "post",
      data,
    }),

  unlock: (data: { month: number; year: number; note: string }): AxiosPromise<any> =>
    request({
      url: "/v1/admin/commission/unlock",
      method: "post",
      data,
    }),
};
